import { createSelector } from 'reselect';

class OrderSelectors {
    static getProgress = (state) => state.order.progress;

    static getExcelOrderProgress = (state) => state.order.progress;

    static getSelectedTransaction = (state) => state.order.selectedTransaction;

    static getCancelProgress = (state) => state.order.cancelProgress;

    static getExcelOrderCancelProgress = (state) => state.order.cancelProgress;

    static getLastTransaction = (state) => state.order.lastTransaction;

    static orderInProgress = createSelector(
        OrderSelectors.getProgress,
        (progress) => progress === 'inprogress'
    );

    static excelOrderInProgress = createSelector(
        OrderSelectors.getExcelOrderProgress,
        (progress) => progress === 'inprogress'
    );

    static orderStarted = createSelector(
        OrderSelectors.getProgress,
        (progress) => progress !== 'unknown'
    );

    static excelOrderStarted = createSelector(
        OrderSelectors.getExcelOrderProgress,
        (progress) => progress !== 'unknown'
    );

    static orderIsComplete = createSelector(
        OrderSelectors.getProgress,
        (progress) => ['complete', 'error'].indexOf(progress) > -1
    );

    static excelOrderIsComplete = createSelector(
        OrderSelectors.getExcelOrderProgress,
        (progress) => ['complete', 'error'].indexOf(progress) > -1
    );

    static orderIsSuccessful = createSelector(
        OrderSelectors.getProgress,
        (progress) => progress === 'complete'
    );

    static excelOrderIsSuccessful = createSelector(
        OrderSelectors.getExcelOrderProgress,
        (progress) => progress === 'complete'
    );

    static orderFailed = createSelector(
        OrderSelectors.getProgress,
        (progress) => progress === 'error'
    );

    static excelOrderFailed = createSelector(
        OrderSelectors.getExcelOrderProgress,
        (progress) => progress === 'error'
    );

    static excelOrderPassed = createSelector(
        OrderSelectors.getExcelOrderProgress,
        (progress) => progress === 'complete'
    );

    static cancelInProgress = createSelector(
        OrderSelectors.getCancelProgress,
        (progress) => progress === 'inprogress'
    );

    static excelOrderCancelInProgress = createSelector(
        OrderSelectors.getExcelOrderCancelProgress,
        (progress) => progress === 'inprogress'
    );

    static cancelIsComplete = createSelector(
        OrderSelectors.getCancelProgress,
        (progress) => progress == 'complete'
    );

    static excelOrderCancelIsComplete = createSelector(
        OrderSelectors.getExcelOrderCancelProgress,
        (progress) => progress == 'complete'
    );
}

export default OrderSelectors;



// WEBPACK FOOTER //
// ./app/selectors/order.js